import Login from "views/examples/Login.js";
import Reportes from "views/examples/Reportes";
import Ordenes from "views/examples/Ordenes";
import OrdenesHistorico from "views/examples/OrdenesHistorico";
import Perfil from "views/examples/Profile";
import ReporteTaller from "views/examples/ReporteTaller";

var routesTaller = [
  {
    path: "/Ordenes",
    name: "Ordenes",
    icon: "ni ni-shop text-blue",
    component: <Ordenes />,
    layout: "/admin",
  },
  {
    path: "/OrdenesHisorico",
    name: "Órdenes Historico",
    icon: "ni ni-single-02 text-blue",
    component: <OrdenesHistorico />,
    layout: "/admin",
  },

  {
    path: "/reporteTaller",
    name: "Reportes Taller",
    icon: "ni ni-folder-17 text-blue",
    component: <ReporteTaller />,
    layout: "/admin",
  },

  {
    path: "/login",
    name: "",
    component: <Login />,
    layout: "/auth",
  },
];
export default routesTaller;
